export const Country = [
  { isoCode: 'US', flagName: 'us', name: 'United States' },
  { isoCode: 'UK', flagName: 'gb', name: 'United Kingdom' },
  { isoCode: 'CA', flagName: 'ca', name: 'Canada' },
  { isoCode: 'AU', flagName: 'au', name: 'Australia' },
];

export const ChartColorSet = ['#73C17B', '#7ED4FD', '#2DA2FC', '#F7D3A6', '#B7BFC6'];

export const LineChartColorSet = ['#617EEC', '#FDAB3B', '#67D18A', '#7ED4FD', '#B7BFC6'];

export const ResearchEvent = {
  RESEARCH_ADVERTISER_TAB_CHANGED: 'researchadvtabchanged',
  COMPARE_COMPETITORS_CHANGED: 'comparecompetitorschanged',
  RESEARCH_SEO_KEYWORDS_GROUPING_CHANGED: 'researchseokwgroupingchanged',
  RELATED_KEYWORDS_LIMIT_REACHED: 'relatedkeywordslimitreached',
};

export const PpcResearchAdvertiserTab = {
  SUMMARY: 'summary',
  KEYWORDS: 'keywords',
  ADS: 'ads',
  LPS: 'landing-pages',
  COMPETITORS: 'competitors',
  COMPARE: 'compare',
};

export const SeoResearchAdvertiserTab = {
  SUMMARY: 'summary',
  KEYWORDS: 'keywords',
  COMPETITORS: 'competitors',
  BACKLINKS: 'backlinks',
};

export const PpcResearchKeywordTab = {
  SUMMARY: 'summary',
  COMPETITORS: 'competitors',
  ADS: 'ads',
  RELATED_KEYWORDS: 'related-keywords',
};

export const SeoResearchKeywordTab = {
  SUMMARY: 'summary',
  COMPETITORS: 'competitor',
  RELATED_KEYWORDS: 'related-keywords',
};

export const ResearchLimit = {
  MAX_EXPORT_SIZE: 100000,
  MAX_COMPARE_DOMAINS: 3,
  MAX_SUMMARY_SEO_GROUP_KEYWORDS: 5,
  MAX_BACKLINKS_FILTERING_ROWS: 50000,
  MAX_SEARCH_HISTORY_ITEMS: 100,
  ADVANCED_FILTERS_MAX_ROWS: 10000000,
  ADVANCED_FILTERS_MAX_CHIP_CHARS: 40,
  ADVANCED_FILTERS_MAX_KEYWORDS: 10,
};

export const POLL_TIMEOUT = 500;

export const BACKLINKS_POLL_TIMEOUT = 1500;

export const BACKLINKS_MAX_POLL_COUNT = 20;

export const Engine = {
  GOOGLE: 'Google',
  BING: 'Bing/Yahoo!',
};

export const SerpSource = {
  GOOGLE: 'google',
  BING: 'bing',
};

export const AdNetwordFromEngine = {
  G: 'Google',
  B: 'Bing/Yahoo!',
};

export const ResearchRouteName = {
  LANDING_PAGE: 'research-landing',
  MAIN_TAB: 'research-main-tab',
  MAIN_SERP: 'research-main-serp',
  SUB_TAB: 'research-sub-tab',
};

export const TabLevel = {
  MAIN_TAB: 'mainTab',
  SUB_TAB: 'subTab',
  SERP_TAB: 'serpSource',
};

export const QueryType = {
  DOMAIN: 'url',
  KEYWORD: 'keyword',
};

export const SearchType = {
  DOMAIN: 'Domain',
  KEYWORD: 'Keyword',
};

export const ResearchType = {
  PPC: 'ppc',
  SEO: 'seo',
};

export const ResearchSearchHistoryKey = 'research_search_history';

export const UpgradeMaskingText = 'Upgrade for more results';

export const UpgradeRequiredStatusCode = 402;

export const ResearchExportFormats = {
  EXCEL: 'excel',
  CSV: 'csv',
};
